import DefaultLayout from '../../layout/DefaultLayout';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';

const PhoneConfigPage = () => {
  return (
    <DefaultLayout>
      <Breadcrumb pageName="Configuración de Teléfono" />
      <div className="mt-4 text-lg">
        Esta es la página para configuración de teléfono.
      </div>
    </DefaultLayout>
  );
};

export default PhoneConfigPage;
